export const SESSION_KEYS = {
  ACCESS_TOKEN: 'accessToken',
  REFRESH_TOKEN: 'refreshToken',
  TOKEN_EXP: 'tokenExpiresIn',
  PUBLIC_KEY_PEM: 'loginPublicKeyPem',
  ROLE_TYPE: 'role_type',
  USERNAME: 'username',
  SSO_USER_LOGIN: 'ssoUserLogin',
  USER_SESSION_ID: 'userSessionId',
  FORCE_PASSWORD_RESET: 'forcePasswordReset',
  MFA_ENABLED: 'mfaEnabled',
  IT_ADMIN: 'itAdmin',
  COUNTRY_DETAILS: 'countryDetails',
  LOGIN_SESSION_ID: 'loginSessionId',
}

// Unique id per successful login. Browser history entries are tagged with it so
// entries created in a previous login session can be detected and discarded.
const generateLoginSessionId = () =>
  typeof crypto !== 'undefined' && crypto.randomUUID
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(36).slice(2)}`

export const startLoginSession = () =>
  sessionStorage.setItem(
    SESSION_KEYS.LOGIN_SESSION_ID,
    generateLoginSessionId()
  )

export const getLoginSessionId = () =>
  sessionStorage.getItem(SESSION_KEYS.LOGIN_SESSION_ID) || ''

export const setAccessToken = (token, expiresSeconds) => {
  sessionStorage.setItem(SESSION_KEYS.ACCESS_TOKEN, token)
  if (expiresSeconds != null) {
    sessionStorage.setItem(SESSION_KEYS.TOKEN_EXP, String(expiresSeconds))
  }
}

export const setRefreshToken = token => {
  if (token) sessionStorage.setItem(SESSION_KEYS.REFRESH_TOKEN, token)
}

export const getAccessToken = () =>
  sessionStorage.getItem(SESSION_KEYS.ACCESS_TOKEN) || ''

export const clearSessionAuth = () => {
  Object.values(SESSION_KEYS).forEach(key => sessionStorage.removeItem(key))

  // Clear all localStorage except rememberMe preferences
  const rememberMe = localStorage.getItem('rememberMe')
  const savedUsername = localStorage.getItem('savedUsername')
  localStorage.clear()
  if (rememberMe) localStorage.setItem('rememberMe', rememberMe)
  if (savedUsername) localStorage.setItem('savedUsername', savedUsername)
}

export const setPublicKeyPem = pem =>
  sessionStorage.setItem(SESSION_KEYS.PUBLIC_KEY_PEM, pem)

export const getPublicKeyPem = () =>
  sessionStorage.getItem(SESSION_KEYS.PUBLIC_KEY_PEM) || ''

export const getRefreshToken = () =>
  sessionStorage.getItem(SESSION_KEYS.REFRESH_TOKEN) || ''

export const setRoleType = roleType =>
  sessionStorage.setItem(SESSION_KEYS.ROLE_TYPE, roleType)
export const getRoleType = () =>
  sessionStorage.getItem(SESSION_KEYS.ROLE_TYPE) || ''

// Username Added
export const setUsername = username =>
  sessionStorage.setItem(SESSION_KEYS.USERNAME, username)
export const setSSOUserLogin = ssoUserLogin =>
  sessionStorage.setItem(SESSION_KEYS.SSO_USER_LOGIN, ssoUserLogin)
export const setUserSessionId = userSessionId =>
  sessionStorage.setItem(SESSION_KEYS.USER_SESSION_ID, userSessionId)
export const getUsername = () =>
  sessionStorage.getItem(SESSION_KEYS.USERNAME) || ''

export const getUserSessionId = () =>
  sessionStorage.getItem(SESSION_KEYS.USER_SESSION_ID) || ''

// Auth Flags
export const setForcePasswordReset = value =>
  sessionStorage.setItem(SESSION_KEYS.FORCE_PASSWORD_RESET, String(value))
export const getForcePasswordReset = () =>
  sessionStorage.getItem(SESSION_KEYS.FORCE_PASSWORD_RESET) === 'true'

export const setMfaEnabled = value =>
  sessionStorage.setItem(SESSION_KEYS.MFA_ENABLED, String(value))
export const getMfaEnabled = () =>
  sessionStorage.getItem(SESSION_KEYS.MFA_ENABLED) === 'true'

export const setItAdmin = value =>
  sessionStorage.setItem(SESSION_KEYS.IT_ADMIN, String(value))
export const getItAdmin = () =>
  sessionStorage.getItem(SESSION_KEYS.IT_ADMIN) === 'true'

export const setCountryDetails = value =>
  sessionStorage.setItem(SESSION_KEYS.COUNTRY_DETAILS, JSON.stringify(value))

export const getCountryDetails = () =>
  sessionStorage.getItem(SESSION_KEYS.COUNTRY_DETAILS)
    ? JSON.parse(sessionStorage.getItem(SESSION_KEYS.COUNTRY_DETAILS))
    : null
